import { WebGLRenderer, ACESFilmicToneMapping, PCFShadowMap } from 'three';

export function Renderer (canvas:any, sizes:any)
{
	var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	const renderer:any = new WebGLRenderer({
		canvas: canvas,
		alpha:true,
		antialias:true,
	})
	renderer.setSize(sizes.width, sizes.height)
	if (isMobile) {
		renderer.setPixelRatio(Math.min(window.devicePixelRatio, .8))
	}else{
		renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1))
	}
	renderer.toneMapping = ACESFilmicToneMapping;
	renderer.toneMappingExposure = 1;
	renderer.shadowMap.enabled = true;
	renderer.shadowMap.type = PCFShadowMap;
	renderer.physicallyCorrectLights = true;

	return renderer;
}